module.exports = __webpack_public_path__ + "static/media/library.3ef628f8.svg";